import { createMuiTheme } from '@material-ui/core/styles';

import Color from 'color';
import main from './main';

export const themes = {
    main: createMuiTheme(main),
};



export const color = (
    palette: string = 'main',
    color: string = 'primary') => {

    let c = null;

    if (!themes[palette] || !themes[palette][color]) {
        console.warn(`Color ${palette} or ${color} doesn't exists. Please use one of the follow colors: ${Object.keys(themes)}`);
        palette = 'main';
        color = 'primary'; 
    }

    c = themes[palette][color];

    return Color(c).hex();
}

export const darker = (
    p: string, 
    c: string, 
    alpha: number = 0.5) => {
    c = color(p, c);
    return Color(c).darken(alpha).hex();
}

export const lighter = (
    p: string, 
    c: string, 
    alpha: number = 0.25) => {
    c = color(p, c);
    return Color(c).lighten(alpha).hex();
}